function modal({parentEl, contents = '', onAccept = () => null, onCancel = () => null, onClose = () => null} = {}) {
    const module = {};
    const view = init();

    module.open = function open() {
        view.el.classList.add('open');
    };

    module.close = function close() {
        view.el.classList.remove('open');
    };

    module.remove = function remove() {
        view.remove();
    };

    function init() {
        const View = Backbone.View.extend({
            events: {
                'click .action_accept': onAccept,
                'click .action_cancel': onCancel,
                'click .action_close': onClose,
            },
            initialize() {
                parentEl.appendChild(this.el);
                Odigeo.once('routeChange', () => {
                    module.remove();
                });
            },
        });

        const el = document.createElement('div');
        el.innerHTML = contents;

        return new View({
            el: el.firstElementChild,
        });
    }

    return module;
}

module.exports = {
    factory: modal,
};
